import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import type {
  MediaUploadAbortRequest,
  MediaUploadCompleteRequest,
  MediaUploadCompleteResponse,
  MediaUploadInitiateRequest,
  MediaUploadInitiateResponse,
  MediaUploadPreflightRequest,
  MediaUploadPreflightResponse,
  MediaUploadSequenceInitiateRequest,
  MediaUploadSequenceInitiateResponse,
} from '@/types/dtos/media/media-upload.dto.ts';

const mediaUploadBase = (mediaId: string) => `${import.meta.env.VITE_API_URL}/media/${mediaId}/upload`;

export async function mediaUploadPreflight(
  mediaId: string,
  body: MediaUploadPreflightRequest,
  token: string,
): Promise<MediaUploadPreflightResponse> {
  return sendJSONRequest({
    url: `${mediaUploadBase(mediaId)}/preflight`,
    method: METHOD.POST,
    body,
    token,
  }) as Promise<MediaUploadPreflightResponse>;
}

export async function mediaUploadInitiate(
  mediaId: string,
  body: MediaUploadInitiateRequest,
  token: string,
): Promise<MediaUploadInitiateResponse> {
  return sendJSONRequest({
    url: `${mediaUploadBase(mediaId)}/initiate`,
    method: METHOD.POST,
    body,
    token,
  }) as Promise<MediaUploadInitiateResponse>;
}

export async function mediaUploadComplete(
  mediaId: string,
  body: MediaUploadCompleteRequest,
  token: string,
): Promise<MediaUploadCompleteResponse> {
  return sendJSONRequest({
    url: `${mediaUploadBase(mediaId)}/complete`,
    method: METHOD.POST,
    body,
    token,
  }) as Promise<MediaUploadCompleteResponse>;
}

export async function mediaUploadAbort(mediaId: string, body: MediaUploadAbortRequest, token: string): Promise<void> {
  await sendJSONRequest({
    url: `${mediaUploadBase(mediaId)}/abort`,
    method: METHOD.POST,
    body,
    token,
  });
}

export async function mediaUploadHeartbeat(
  mediaId: string,
  body: MediaUploadAbortRequest,
  token: string,
): Promise<void> {
  await sendJSONRequest({
    url: `${mediaUploadBase(mediaId)}/heartbeat`,
    method: METHOD.POST,
    body,
    token,
  });
}

/** Abort that can finish after the page starts unloading. */
export function mediaUploadAbortKeepalive(mediaId: string, uploadId: string, token: string): void {
  void fetch(`${mediaUploadBase(mediaId)}/abort`, {
    method: 'POST',
    keepalive: true,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ uploadId }),
  }).catch(() => undefined);
}

export async function mediaUploadSequenceInitiate(
  mediaId: string,
  body: MediaUploadSequenceInitiateRequest,
  token: string,
): Promise<MediaUploadSequenceInitiateResponse> {
  return sendJSONRequest({
    url: `${mediaUploadBase(mediaId)}/sequence/initiate`,
    method: METHOD.POST,
    body,
    token,
  }) as Promise<MediaUploadSequenceInitiateResponse>;
}
